/**
 * The moment of the day (docs/ROLE_ONTOLOGY.md moment map). Today puts one primary thing in front of each role per moment.
 * Derived from the location's hours only: before open, opening (first 90 minutes), the day, close (last hour and the hour
 * after), evening. `?moment=` overrides it for demos.
 */
import { momentAt, momentOf as coreMomentOf, type HoursSource, type Moment } from "@logwave/core";
export type { Moment };
export const MOMENTS: Moment[] = ["before", "opening", "day", "close", "evening"];

const toMin = (s: string) => { const [h, m] = s.split(":").map(Number); return (h ?? 0) * 60 + (m ?? 0); };

/** Core's momentOf (one rule set, T7) over the location's local hours. Late night after close stays "evening". */
export function momentOf(openAt: string, closeAt: string, nowHHMM: string): Moment {
  return coreMomentOf(toMin(nowHHMM), toMin(openAt), toMin(closeAt));
}

/** The moment now from the location's weekly hours (core momentAt): a closed day is "evening"; past midnight on an overnight day is still closing. */
export function momentNow(loc: HoursSource & { timezone?: string }, now: Date = new Date()): Moment {
  return momentAt(loc, now, loc.timezone || "America/Denver");
}

export const MOMENT_LABEL: Record<Moment, string> = { before: "Before opening", opening: "Opening", day: "During the day", close: "Closing", evening: "Evening" };
